import React from "react";

const AnimatedBackground = () => {
  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: -1,
        background:
          "radial-gradient(600px 300px at 20% 10%, rgba(201,148,60,0.10), transparent 60%)," +
          "radial-gradient(500px 250px at 80% 20%, rgba(139,26,26,0.08), transparent 60%)," +
          "radial-gradient(400px 200px at 50% 90%, rgba(201,148,60,0.06), transparent 60%)," +
          "radial-gradient(400px 200px at 10% 80%, rgba(30,77,53,0.06), transparent 60%)",
      }}
    />
  );
};

export default AnimatedBackground;
